<template>
  <div class="blog">
    <div class="main">
      <div>
        <h1>There are no blogs available.</h1>
        <p>Please come back later</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Blog'
}
</script>

<style>
.main {
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/views/Blog.vue